import { FC, useContext } from 'react';
import styled from 'styled-components';
import { IconButton, Tooltip } from '@mui/material';
import { ArrowBack } from '@mui/icons-material';
import { ProfileSetupContext } from './ProfileSetupContext';

const BackButton = styled(IconButton)`
  position: absolute;
  left: 0;
  top: 0;
`;

const ProfileSetupBackButton: FC = () => {
  const { goToPreviousStep, canGoToPreviousStep } =
    useContext(ProfileSetupContext);

  if (!canGoToPreviousStep) return null;

  return (
    <Tooltip title="Back" arrow placement="top" enterDelay={1000}>
      <BackButton onClick={goToPreviousStep}>
        <ArrowBack color="primary" />
      </BackButton>
    </Tooltip>
  );
};

export default ProfileSetupBackButton;
